import i18n from '@/utils/i18n';

export const attachPlanFields = {
    items: [
        {
            trackBy: 'title',
            label: i18n.t('login.wallkit_pricing_plan'),
            placeholder: i18n.t('login.select_wallkit_pricing_plan'),
            type: 'select',
            name: 'pricing_plan',
            labelKey: 'title',
            required: true,
            options: [],
            loading: false
        },
    ]
}

const fields =
    {
        items: [
            {
                label: i18n.t('form.website_name'),
                placeholder: i18n.t('form.website_name'),
                required: true,
                type: 'text',
                name: 'website_title'
            },
            {
                label: i18n.t('form.website_url'),
                placeholder: i18n.t('form.website_url'),
                required: true,
                type: 'text',
                name: 'website_url'
            },
            {
                trackBy: 'title',
                label: i18n.t('login.wallkit_pricing_plan'),
                placeholder: i18n.t('login.select_wallkit_pricing_plan'),
                type: 'select',
                name: 'pricing_plan',
                required: true,
                options: [],
                loading: false
            },
            {
                name: "active",
                type: "switch",
                label: i18n.t('form.active'),
                title: i18n.t('global.yes'),
                titleFalse: i18n.t('global.no')
            }
        ]
    };

export default fields
